import React from 'react';
import missionImg from '../assets/images/about/mission.jpg';
import visionImg from '../assets/images/about/vision.jpg';
import valuesImg from '../assets/images/about/values.jpg';
import journeyImg from '../assets/images/about/journey.jpg';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      {/* Clean About Header */}
      <div className="about-header">
        <div className="about-header-container">
          <div className="about-header-content">
            <h1 className="about-header-title">About we2 exporters</h1>
            <p className="about-header-subtitle">Rooted in Nature. Delivered with Trust.</p>
          </div>
          <div className="about-header-image">
            <img 
              src={missionImg}
              alt="Natural agro products"
              className="about-header-img"
            />
          </div>
        </div>
      </div>

      {/* Who We Are */}
      <div className="about-container">
        <div className="about-content-section">
          <div className="about-text-content">
            <h2 className="about-section-title">Who We Are</h2>
            <p className="about-paragraph">
              <strong>we2 exporters</strong> is a growing agro-export company based in South India, focused on supplying high-quality natural food products and traditional agro commodities to international markets. Our product portfolio includes millets, edible oils, spices, palm products, fresh produce, organic farming inputs, and handcrafted items.
            </p>
            <p className="about-paragraph">
              We collaborate closely with local farmers and rural producers to source naturally grown raw materials, ensuring freshness, traceability, and consistent quality in every shipment.
            </p>
          </div>
          <div className="about-image-content">
            <img 
              src={visionImg}
              alt="Farmers harvesting crops"
              className="about-image"
            />
          </div>
        </div>

        {/* Our Product Philosophy */}
        <div className="about-content-section about-reverse">
          <div className="about-image-content">
            <img 
              src={valuesImg}
              alt="Assorted millets and grains"
              className="about-image"
            />
          </div>
          <div className="about-text-content">
            <h2 className="about-section-title">Our Product Philosophy</h2>
            <p className="about-paragraph">
              We believe food should nourish both people and the planet. Traditional grains like millets are naturally rich in dietary fiber, minerals, antioxidants, and essential nutrients. Compared to refined cereals, millets release energy slowly and support balanced nutrition, making them ideal for modern healthy lifestyles.
            </p>
            <p className="about-paragraph">
              At <strong>we2 exporters</strong>, our products are carefully cleaned, processed, and packed under hygienic conditions to preserve natural aroma, flavor, and nutritional value — making them suitable for international export.
            </p>
          </div>
        </div>

        {/* Why Choose we2 exporters */}
        <div className="about-why-choose">
          <h2 className="about-section-title about-center">Why Choose we2 exporters</h2>
          <div className="about-features-grid">
            <div className="about-feature-card">
              <div className="about-feature-icon">✓</div>
              <h3 className="about-feature-title">Carefully Sourced Natural Products</h3>
              <p className="about-feature-text">Direct sourcing from trusted farms and producers</p>
            </div>
            <div className="about-feature-card">
              <div className="about-feature-icon">✓</div>
              <h3 className="about-feature-title">Strong Farmer Network</h3>
              <p className="about-feature-text">Close collaboration with local farming communities</p>
            </div>
            <div className="about-feature-card">
              <div className="about-feature-icon">✓</div>
              <h3 className="about-feature-title">Export-Grade Packaging</h3>
              <p className="about-feature-text">International standard packaging and handling</p>
            </div>
            <div className="about-feature-card">
              <div className="about-feature-icon">✓</div>
              <h3 className="about-feature-title">Wide Agro Product Range</h3>
              <p className="about-feature-text">Diverse portfolio from oils to handicrafts</p>
            </div>
            <div className="about-feature-card">
              <div className="about-feature-icon">✓</div>
              <h3 className="about-feature-title">Flexible Bulk Supply</h3>
              <p className="about-feature-text">Scalable orders to meet your business needs</p>
            </div>
            <div className="about-feature-card">
              <div className="about-feature-icon">✓</div>
              <h3 className="about-feature-title">Transparent Business Practices</h3>
              <p className="about-feature-text">Clear communication and reliable partnerships</p>
            </div>
          </div>
        </div>

        {/* Our Commitment */}
        <div className="about-content-section">
          <div className="about-text-content">
            <h2 className="about-section-title">Our Commitment</h2>
            <p className="about-paragraph">
              At <strong>we2 exporters</strong>, we are committed to responsible sourcing, transparent operations, and long-term partnerships. From edible oils and spices to millets and palm products, every item is selected with care to meet international buyer expectations.
            </p>
            <p className="about-paragraph">
              As a young and dynamic export brand, our mission is simple — to connect global markets with India's natural agricultural wealth while supporting sustainable rural livelihoods.
            </p>
          </div>
          <div className="about-image-content">
            <img 
              src={journeyImg}
              alt="Quality checking and export packaging"
              className="about-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
